import { useQuery } from '@tanstack/react-query'

import { useOfficePagePermissions } from '@/hooks/useOfficePagePermissions'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { getServiceReqs } from '../serviceReqService'
import { GetServiceReqsPayload } from '../types/GetServiceReqsPayload'

export function useServiceReqs(params: GetServiceReqsPayload = {}) {
  const { canViewServiceReqs } = useOfficePagePermissions()
  const queryKey = [
    QUERY_KEYS.SERVICE_REQS,
    params.type,
    params.status,
    params.customerId,
    params.month,
    params.responsibleParty,
    params.reportedToResponsibleParty,
    params.onlyPending,
  ].filter(v => v !== undefined)

  return useQuery({
    queryKey,
    queryFn: () => getServiceReqs(params),
    enabled: canViewServiceReqs,
  })
}
